import { cx } from "cva";
import { SocialMediaShareFlyout } from "~/components/SocialMediaShareFlyout";
import { SocialMediaShareFlyoutButton } from "~/components/SocialMediaShareFlyout/SocialMediaShareFlyoutButton";
import { SocialMediaShareMenu } from "~/components/SocialMediaShareMenu";
import { SocialMediaShareMenuButton } from "~/components/SocialMediaShareMenu/SocialMediaShareMenuButton";
import { IconButton } from "~/ui-library";
import { ArrowDownTrayIcon, BookmarkIcon } from "~/ui-library/icons";
import { getButtonStyles } from "~/ui-library/shared-styles/shared-button-styles";

export type ArticleActionToolbarProps = {
  containerClassName?: string;
  onShareClick?: () => void;
  onBookmarkClick?: () => void;
  onDownloadClick?: () => void;
  showBookmark?: boolean;
  showDownload?: boolean;

  /** Title of social media/email posts */
  shareTitle: string;
  /** Url of social media/email posts */
  shareUrl: string;
};

const shareButtonStyles = getButtonStyles({
  variant: "default",
});

export const ArticleActionToolbar: React.FC<ArticleActionToolbarProps> = ({
  containerClassName,
  onBookmarkClick,
  onDownloadClick,
  showBookmark,
  showDownload,
  shareTitle,
  shareUrl,
}) => (
  <div className={cx(containerClassName, "flex w-fit gap-s")}>
    <div className="hidden lg:block">
      <SocialMediaShareMenu
        menuButton={
          <SocialMediaShareMenuButton
            aria-label="Open share menu"
            className={shareButtonStyles}
          />
        }
        shareTitle={shareTitle}
        shareUrl={shareUrl}
      />
    </div>

    <div className="lg:hidden">
      <SocialMediaShareFlyout
        shareTitle={shareTitle}
        shareUrl={shareUrl}
        renderButton={({ onClick }) => (
          <SocialMediaShareFlyoutButton
            aria-label="Share this article"
            className={shareButtonStyles}
            onClick={onClick}
          />
        )}
      />
    </div>

    {showBookmark ? (
      <IconButton
        aria-label="Bookmark this article"
        iconClassName="fill-transparent"
        onClick={onBookmarkClick}
        SvgIcon={BookmarkIcon}
      />
    ) : null}

    {showDownload ? (
      <IconButton
        aria-label="Download this article"
        onClick={onDownloadClick}
        SvgIcon={ArrowDownTrayIcon}
      />
    ) : null}
  </div>
);
